import { useCallback } from "react";

import ActionIconButton from "@components/buttons/ActionIconButton";
import useMyExpert from "@hooks/useMyExpert";
import { ExpertGlobalRoleEnum, TimeLogFragment as TimeLog, TimeLogActorTypeEnum } from "@typing/Generated";

type Props = {
  onDelete: (timeLog: TimeLog) => void;
  onEdit: (timeLog: TimeLog) => void;
  timeLog: TimeLog;
};

const TimeLogActions = ({ onDelete, onEdit, timeLog }: Props) => {
  const handleDelete = useCallback(() => {
    onDelete(timeLog);
  }, [onDelete, timeLog]);

  const handleEdit = useCallback(() => {
    onEdit(timeLog);
  }, [onEdit, timeLog]);

  const myExpert = useMyExpert();

  if (
    myExpert &&
    timeLog.actorType === TimeLogActorTypeEnum.expert &&
    (timeLog.actorId === myExpert.id || myExpert?.expertGlobalRole === ExpertGlobalRoleEnum.manager)
  ) {
    return (
      <>
        <ActionIconButton ariaLabelKey="accessibility.ariaLabels.edit" icon="edit" onClick={handleEdit} />
        <ActionIconButton ariaLabelKey="accessibility.ariaLabels.delete" icon="trash" onClick={handleDelete} />
      </>
    );
  }

  return null;
};

export default TimeLogActions;
